// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"472":"49801224","736":"67bd7c47","872":"4ed60549"}[chunkId] + ".css";
};